import { useIonRouter } from '@ionic/react'
import { LogoText, Page } from '@/styles/pages/Intro'
import TisitWordmark from '@assets/icons/tisit_logo_full.svg'
import { useEffect } from 'react'
import { ROUTES } from '@shared/constants/routes'
import { authTokenStorage } from '@shared/lib/authTokenStorage'

export default function Intro() {
	const nav = useIonRouter()

	useEffect(() => {
		let cancelled = false

		const checkUserStatus = async () => {
			const tokens = await authTokenStorage.getTokens()
			if (cancelled) return

			const hasValidAccessToken = Boolean(
				tokens?.accessToken &&
					!authTokenStorage.isAccessTokenExpired(tokens.accessToken),
			)
			const hasValidRefreshToken = Boolean(
				tokens?.refreshToken &&
					!authTokenStorage.isRefreshTokenExpired(tokens.refreshToken),
			)

			if (hasValidAccessToken || hasValidRefreshToken) {
				nav.push(ROUTES.auth.enterBaseInfo)
				return
			}

			nav.push(ROUTES.overall.hello)
		}

		void checkUserStatus()

		return () => {
			cancelled = true
		}
	}, [nav])

	return (
		<Page>
			<LogoText src={TisitWordmark} />
		</Page>
	)
}
